<template>
  <div id="wrapper">
    <TextHeader
      :headerTitle="$t('media.title')"
      header-bg="radial-gradient(circle farthest-corner at 13% 102%, #3b464e 21%, #315875), linear-gradient(180deg, #000, #000)"
    />
    <Submenu
      :submenuItems="submenuItems"
      :selectedItem="selectedItem"
      :background-color="'#a2a2a2'"
      basePath="media-section"
      v-on:changeItem="changeItem"
    />
    <div id="content" class="w-container">
      <transition name="change" mode="out-in">
        <Press v-if="selectedItem === 'press'" />
        <MediaAppearances v-if="selectedItem === 'media'" />
        <BrandingKit v-if="selectedItem === 'branding'" />
        <Gallery v-if="selectedItem === 'gallery'" />
        <Partners v-if="selectedItem === 'partners'" />
      </transition>
    </div>
  </div>
</template>

<script>
import TextHeader from "../TextHeader";
import Submenu from "../Submenu";
import Press from "./Press";
import MediaAppearances from "./MediaAppearances";
import BrandingKit from "./BrandingKit";
import Gallery from "./Gallery";
import Partners from "@/components/media/Partners";
export default {
  name: "Media",
  components: {
    Partners,
    Gallery,
    BrandingKit,
    MediaAppearances,
    Press,
    Submenu,
    TextHeader,
  },
  data() {
    return {
      submenuItems: [
        {
          id: "press",
          value: "media",
        },
        {
          id: "partners",
          value: this.$t("media.partners"),
        },
        // {
        //     id: 'media',
        //     value: 'Apariții Media'
        // },
        // {
        //     id: 'branding',
        //     value: 'Branding Kit'
        // },
        {
          id: "gallery",
          value: this.$t("media.gallery"),
        },
      ],
      selectedItem: "press",
    };
  },
  methods: {
    changeItem: function (item) {
      this.selectedItem = item.id;
    },
  },
  mounted() {
    this.selectedItem = this.$route.params.section || "press";
  },
};
</script>

<style scoped>
#wrapper {
  background-color: #f0f0f0;
  width: 100%;
}

/*.change-enter {*/
/*!*transform: translateX(100%);*!*/
/*opacity: 0;*/
/*}*/

/*.change-leave-to {*/
/*!*transform: translateX(-100%);*!*/
/*opacity: 0;*/
/*}*/

/*.change-enter-active, .change-leave-active {*/
/*transition: opacity 1s;*/
/*}*/
</style>
